import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import Link from 'next/link'
import { FaArrowAltCircleRight, FaLaptop, FaRegCreditCard, FaToolbox } from 'react-icons/fa'
import { MdAssignmentInd } from 'react-icons/md'
import { BsArrowRightCircle , BsCheckLg } from 'react-icons/bs'
import { getRequestJSON } from '../../../api/index/location-api'
import { AppInstall } from '../../../components/index/AppInstall'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const { modifiedDate, month, year } = getArticleDateTime()

    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")

  return {
      props: {
        modifiedDate,
        requestCategorySettings
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const requestCategorySettings = props.requestCategorySettings;

  return (
    <>
      <Head>
        <title>Part Time Cleaner Jobs In Singapore | Home Cleaning Jobs</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Enjoy the flexibility of part time cleaner jobs and start earning instantly. Apply now to get clients, manage jobs and get paid with ease."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-cleaner-jobs" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Part Time Cleaner Jobs In Singapore | Home Cleaning Jobs`}/>
        <meta property="og:description" content="A mobile and web application solution for Part Time Helpers to get clients, manage jobs and get paid with ease." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-01T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper-in-gray-uniform-living.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-cleaner-jobs"/>
        <meta name="twitter:title" content={`Part Time Cleaner Jobs In Singapore | Home Cleaning Jobs`}/> 
        <meta name="twitter:description" content="A mobile and web application solution for Part Time Helpers to get clients, manage jobs and get paid with ease."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-cleaner-jobs"},"headline":"Part Time Cleaner Jobs In Singapore | Home Cleaning Jobs","description":"A mobile and web application solution for Part Time Helpers to get clients, manage jobs and get paid with ease.","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/part-time-helper/part-time-helper-in-gray-uniform-living.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-01T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"part-time-maid","item":"https://www.stringssg.com/sg/part-time-cleaner-singapore"},{"@type":"ListItem","position":2,"name":"service-provider"}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-cleaner-jobs"/>
        </Head>
        <div>
            <div id="cleaner-job" className="-mt-14 relative overflow-hidden" style={{height : "700px"}}>            
                <div className="h-full w-full relative">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300'
                    src={s3Static + "part-time-helper/part-time-helper.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'top'}}
                    alt='StringsSG Part time domestic helper Sign Up'
                    priority="false"
                    quality={100}
                    />
                </div>        
                <div id="campaign" className='absolute flex justify-between items-center left-0 bottom-0 top-0 w-full'>
                    <div className='bg-black/50 rounded-lg w-fit mx-auto p-5 text-center text-white'> 
                        <div className='text-lg'><strong>Home Cleaning Jobs</strong></div>
                        <div className='py-3 pt-10'>
                            <Link href="/service-provider-signup" prefetch={false} className='px-6 py-3 border border-white text-2xl rounded-lg font-bold'>
                                Apply Now
                            </Link>
                        </div>
                        <div className='text-lg pt-5'><strong>Earn $16-$22 per hour</strong></div>
                    </div>  
                </div>
            </div>
            <div className='max-w-5xl mx-auto py-6 px-2'>
                <div className='grid md:grid-cols-2 gap-10 items-center'>
                    <div className='space-y-10 px-2'>
                        <h1 className='text-2xl md:text-4xl text-center'>
                            <strong>Join us as a Home Cleaning Specialist</strong>
                        </h1>
                        <div className='space-y-2 leading-8 text-sm'>
                            <p>
                                Accept 100s of part time home cleaning jobs from the StringsSG mobile app. Start serving clients instantly without worrying about sales, marketing, 
                                job scheduling, team management, receipt/invoice & service records. 
                            </p>
                            <p>
                                We are Singapore&apos;s most popular professional & home service booking platform.
                            </p>
                            <div className='flex justify-center pt-2'>
                                <div className='space-y-2'>
                                    <div className='flex items-center'>
                                        <FaArrowAltCircleRight/>&nbsp;Same Day Earning!
                                    </div>
                                    <div className='flex items-center'>
                                        <FaArrowAltCircleRight/>&nbsp;24/7 Support
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='relative w-full h-120'>
                        <Image
                            src={s3Static + "part-time-helper/part-time-helper-posing.png"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'top'}}  
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Part time helper job - StringsSG'
                        />     
                    </div>  
                </div>
            </div>
            <AppInstall/>
            <div className="h-145 w-full relative bg-black">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300 opacity-40'
                    src={s3Static + "blog/living/part-time-helper/helper-cleaning-equipment-tools.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'top'}}
                    alt='StringsSG Part Time Domestic Helper Sign Up'
                    priority="false"
                />
                <div className='absolute flex justify-between items-center left-0 right-0 bottom-0 top-0 max-w-5x'>
                    <div className='mx-auto p-5 space-y-10 text-center text-white'> 
                        <div className='text-2xl uppercase'><strong>What we offer</strong></div>
                        <div className='py-3 text-xl space-y-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Get clients with ease</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Job management</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Team management</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Payment management</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-xl'><BsCheckLg/></span><span>Invoice management</span>
                            </div>
                        </div>
                    </div>  
                </div>
            </div> 
            <div id="how-it-works" className="bg-linear-to-tr from-slate-700 to-slate-500 text-gray-100 py-10">
                <div className='max-w-xl md:max-w-5xl mx-auto text-sm leading-7 space-y-10 text-center'>
                    <h2 className="text-xl md:text-2xl text-center uppercase px-2"><strong>How it Works?</strong></h2>
                    <div className="p-3 space-y-4">
                        <div className="flex justify-center">
                            <FaLaptop aria-hidden="true" className='text-8xl' />
                        </div>
                        <h3 className='text-center text-lg'><strong>1. Register</strong></h3>
                        <p className='flex justify-center px-4 max-w-3xl mx-auto'>
                            Sign up as a part-time helper under the Domestic Services category. Set up your bank account to receive payment from jobs.
                        </p>
                    </div>            
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-center">
                        <div className='p-3 space-y-4'>
                            <div className="flex justify-center">
                                <MdAssignmentInd aria-hidden="true" className='text-8xl' />
                            </div>
                            <h3 className='text-center text-lg'><strong>2. Connect</strong></h3>
                            <p className='flex justify-center px-4'>                            
                                Accept a job if you like the location, pricing and service date. Chat with the client, or use the direct Call and Whatsapp features.
                            </p>
                        </div>
                        <div className='p-3 space-y-4'>
                            <div className="flex justify-center">
                                <FaToolbox aria-hidden="true" className='text-8xl'/>
                            </div>
                            <h3 className='text-center text-lg'><strong>3. Service</strong></h3>
                            <p className='flex justify-center px-4'>
                                &quot;Start Job&quot; on the app to start the job as per the confirmed service date and time. 
                            </p>
                        </div>                
                    </div>
                    <div className="p-3 space-y-4">
                        <div className="flex justify-center">
                            <FaRegCreditCard aria-hidden="true" className='text-8xl'/>
                        </div>
                        <h3 className='text-center text-lg'><strong>4. Payment</strong></h3>
                        <p className='flex justify-center px-4 max-w-3xl mx-auto'>
                            &quot;Send Invoice&quot; on the app upon job completion. Your earning will be credited into your payout account.
                        </p>
                    </div>
                </div>
            </div>  
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Jobs</strong>
                </h2>
                <div className='max-w-5xl mx-auto md:grid md:grid-cols-2 gap-5 p-5'>                        
                    <div className='p-2 flex justify-center items-center'>
                        <Image
                            src={s3Static + "blog/living/part-time-helper/female-part-time-helper.png"}
                            height={350}
                            width={350}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='StringsSG Service Provider Jobs'
                        />
                    </div>                
                    <div className='py-2 flex items-center'>
                        <div className='space-y-5 leading-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Instant notification to your mobile and email will be sent when a new job request arrives.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Make sure to have the mobile app installed to be able to respond to the request immediately.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Accept the job if you like the pricing and are available for the requested date and time slot.</span>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>  
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Earnings</strong>
                </h2>
                <div className='max-w-5xl mx-auto md:grid md:grid-cols-4 gap-5 p-5'>
                    <div className='md:col-span-1 p-2 flex justify-center items-center'>
                        <Image
                            src={s3Static + "chip.png"}
                            height={150}
                            width={150}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='StringsSG Service Provider Earnings'
                        />
                    </div>
                    <div className='md:col-span-3 py-2 flex items-center'>
                        <div className='space-y-5'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Accept more jobs for better earning.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>We charge a very competitive and reasonable pricing to the clients.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Set up your payout account with a debit card to get instant payment.</span>
                            </div>
                        </div>
                    </div> 
                </div>
                <div className='text-center py-2'>
                    <h3 className='text-lg font-bold'><span className='uppercase text-xl'>Your Earning  = </span><br/><span>Pricing - ( Discount + Platform fees )</span></h3>
                </div>
                <div className='max-w-6xl mx-auto grid lg:grid-cols-3 gap-5 py-10 px-2 w-full text-center text-sm leading-7'>                    
                    <div className='bg-slate-200 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Pricing</h3>
                        <div>The pricing is auto-calculated by our AI-System based on the service requirements.</div>
                    </div>
                    <div className='bg-amber-50 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Discounts</h3>
                        <div>The client may be eligible for discounts on their request.</div>
                    </div>
                    <div className='bg-slate-200 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Platform fees</h3>
                        <div>We charge a platform fee to cover operational expenses of the platform.</div>
                    </div>
                </div> 
            </div> 
            <div className='text-sm leading-7 py-5'>
                <div className='max-w-3xl mx-auto text-center space-y-4 p-2'>   
                    <h2 className='text-xl font-bold uppercase'>Part-time Helper Earning Calculator</h2>                
                    <p>Use this calculator to get real-time estimation of earning after platform fee. Client discounts are not considered for this estimation.</p>      
                    <p>This AI driven calculator derives real-time earnings estimate based on thousands of data points, clients requirement, platform fee 
                        and several other factors.</p>
                    {/* <div className='flex items-center justify-center text-lg font-bold'> 
                        <span className={(serviceProviderType === 'business' ? " text-orange-600 " : " text-gray-500 ")}>Business&nbsp;</span>                   
                        <label className="switch">
                        <input type="checkbox" name="serviceProviderType" checked={serviceProviderType === 'freelancer'} onChange={(e) => changeServiceProviderType(e)} value={serviceProviderType}/>
                        <span className="slider round"></span>
                        </label>
                        <span className={(serviceProviderType === 'freelancer' ? " text-orange-600 " : " text-gray-500 ")}>&nbsp;Freelancer</span>
                    </div>                  */}
                </div>
            </div>
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Client Communication</strong>
                </h2>
                <div className='max-w-5xl mx-auto md:grid md:grid-cols-2 gap-5 p-5'> 
                    <div className='py-2 flex items-center'>
                        <div className='space-y-5 leading-8'>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>In-built chat system to connect with the client.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Call feature to call the client when necessary.</span>
                            </div>
                            <div className='flex items-center space-x-4'>
                                <span className='text-2xl'><BsArrowRightCircle/></span><span>Seamlessly reschedule service date when needed.</span>
                            </div>
                        </div>
                    </div>                                            
                    <div className='p-2 flex justify-center items-center h-96 relative'>
                        <Image
                            src={s3Static + "blog/living/Fashionable-Women-PNG.png"}
                            fill
                            style={{objectFit: 'cover', objectPosition: 'top'}}
                            alt='StringsSG Communication Systems'
                            priority="false"
                        />
                    </div>                
                </div>
            </div>   
            <div className='py-10 px-2'>
                <h2 className='text-2xl md:text-4xl text-center uppercase'>
                    <strong>Other Features</strong>
                </h2>
                <div className='max-w-6xl mx-auto grid lg:grid-cols-2 gap-5 py-10 px-2 w-full text-center text-sm leading-7'>                    
                    <div className='bg-slate-200 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Job Management Portal</h3>
                        <div>Use this portal to seamlessly track and manage the flow of a job. The usual sequence in Accept Job &gt; Start Job &gt; Send Invoice. 
                            <br/><br/>You also have the option to cancel a job after you have accepted it, in
                            such a case the job gets assigned to another service provider. You cannot cancel a job if you have started working on it.
                        </div>
                    </div>
                    <div className='bg-amber-50 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Team Management</h3>
                        <div>You can create multiple teams under your account and assign jobs to them. Each team will have access only to the jobs assigned to
                            them and manage the job cycle on their own, which will help to cut down your overall time spent on operations.
                            <br/><br/>
                            Easily create a shareable link for the jobs and share it with your associates to help you track and manage the job. 
                        </div>
                    </div>
                    <div className='bg-slate-50 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Payout Account</h3>
                        <div>You can setup and manage your payout account under Account &gt; Payout. We partner with Stripe to enable frictionless payment to your bank account.
                            Instant payouts to Debit cards are available for eligible banks like DBS, OCBC, UOB and many more in Singapore.
                            <br/><br/>
                            This is where you can make transfers to your bank account and add, remove or set default accounts for receiving payments. 
                        </div>
                    </div>
                    <div className='bg-amber-50 p-6 rounded-lg space-y-5'>
                        <h3 className='text-lg font-bold'>Invoice/Receipt Management</h3>
                        <div>We will handle the invoices and receipts for clients.
                            <br/><br/>
                            Access payment from jobs under under Account &gt; Payout &gt; Payment from Jobs. 
                        </div>
                    </div>
                </div> 
            </div>          
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}